import Nullstack from 'nullstack';
export default function IconThreedCubeSphereOff({
  size = 24,
  color = "currentColor",
  stroke = 2
}) {
  const allProps = {
    width: size,
    height: size,
    "stroke-width": stroke,
    stroke: color
  };
  return Nullstack.element("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    class: "inline-flex icon icon-tabler icon-tabler-3d-cube-sphere-off",
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    "stroke-width": "2",
    stroke: "currentColor",
    fill: "none",
    "stroke-linecap": "round",
    "stroke-linejoin": "round",
    ...allProps
  }, "   ", Nullstack.element("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), "   ", Nullstack.element("path", {
    d: "M6 17.6l-2 -1.1v-2.5"
  }), "   ", Nullstack.element("path", {
    d: "M4 10v-2.5l2 -1.1"
  }), "   ", Nullstack.element("path", {
    d: "M10 4.1l2 -1.1l2 1.1"
  }), "   ", Nullstack.element("path", {
    d: "M18 6.4l2 1.1v2.5"
  }), "   ", Nullstack.element("path", {
    d: "M20 14v2"
  }), "   ", Nullstack.element("path", {
    d: "M14 19.9l-2 1.1l-2 -1.1"
  }), "   ", Nullstack.element("path", {
    d: "M18 8.6l2 -1.1"
  }), "   ", Nullstack.element("path", {
    d: "M12 12v2.5"
  }), "   ", Nullstack.element("path", {
    d: "M12 18.5v2.5"
  }), "   ", Nullstack.element("path", {
    d: "M12 12l-2 -1.12"
  }), "   ", Nullstack.element("path", {
    d: "M6 8.6l-2 -1.1"
  }), "   ", Nullstack.element("path", {
    d: "M3 3l18 18"
  }), " ");
}